import { Controller } from "@hotwired/stimulus";

export default class CharCounterController extends Controller {
  static targets = ["input", "count"];
  static values = { max: Number };

  connect() {
    this.countTarget.hidden = true;
  }

  update() {
    const len = this.inputTarget.value.length;
    const max = this.maxValue;

    this.countTarget.hidden = false;
    this.countTarget.textContent = `${len} / ${max}`;

    const remaining = max - len;
    const warningThreshold = Math.max(1, Math.ceil(max * 0.1));
    this.countTarget.dataset.state =
      remaining <= 0 ? "over" : remaining <= warningThreshold ? "warning" : "ok";
  }
}
